// extracted by mini-css-extract-plugin
var _1 = "styles-module__appIcon___mWxM6";
var _2 = "styles-module__appIconsContainer___HPGg9";
var _3 = "styles-module__container___Ssu4s";
var _4 = "styles-module__title____rgeH";
export { _1 as "appIcon", _2 as "appIconsContainer", _3 as "container", _4 as "title" }
